import React, { useEffect, useState } from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'

import { Disclosure } from '@headlessui/react'
import { MenuIcon, XIcon } from '@heroicons/react/outline'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSortDown } from '@fortawesome/free-solid-svg-icons'
import { BACKGROUND_VARIANTS } from './Layouts/MainLayout'

const Navbar = ({ bgVariant }) => {
    const data = useStaticQuery(graphql`
        {
            allStrapiCommisionCategory {
                nodes {
                    Kategoriename
                    Slug
                    id
                }
            }
        }
    `)
    const [isScrolled, setIsScrolled] = useState(false)
    const [hoverDienstleitung, setHoverDienstleitung] = useState(false)
    const [hoverInformationen, setHoverInformationen] = useState(false)

    useEffect(() => {
        const onScroll = () => {
            if (window.pageYOffset > 0) {
                setIsScrolled(true)
            } else {
                setIsScrolled(false)
            }
        }
        // clean up code
        window.removeEventListener('scroll', onScroll)
        window.addEventListener('scroll', onScroll, { passive: true })
        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    return (
        <Disclosure
            as="nav"
            className={` ${isScrolled ? 'active' : ''} ${
                bgVariant === BACKGROUND_VARIANTS.COLOR
                    ? 'nav-color'
                    : 'nav-dark'
            }`}
        >
            {({ open }) => (
                <>
                    <div className="max-w-7xl mx-auto px-2 lg:px-8">
                        <div className="relative flex items-center justify-between h-16">
                            <div className="absolute inset-y-0 left-0 flex items-center lg:hidden">
                                {/* Mobile menu button*/}
                                <Disclosure.Button
                                    className={`inline-flex items-center justify-center p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white ${
                                        bgVariant === BACKGROUND_VARIANTS.COLOR
                                            ? 'text-secondary hover:text-primary hover:bg-gray-700'
                                            : 'text-gray-400 hover:text-white hover:bg-gray-700'
                                    }}`}
                                >
                                    <span className="sr-only">
                                        Open main menu
                                    </span>
                                    {open ? (
                                        <XIcon
                                            className="block h-6 w-6"
                                            aria-hidden="true"
                                        />
                                    ) : (
                                        <MenuIcon
                                            className="block h-6 w-6"
                                            aria-hidden="true"
                                        />
                                    )}
                                </Disclosure.Button>
                            </div>
                            <div className="flex-1 flex items-center justify-center content-center">
                                <div className="flex-shrink-0 flex items-center">
                                    <Link to="/">
                                        <img
                                            className="block lg:hidden xl:block h-auto w-24"
                                            src="https://shop-the-easycode.de/Bilder/Safe-Spark/Safe-Spark_Logo_Small.webp"
                                            alt="Safe-Spark Logo"
                                        />
                                    </Link>
                                </div>
                                <div className="hidden lg:block lg:ml-6 ">
                                    <div className="flex md:space-x-6 lg:space-x-8 h-[64px] items-center">
                                        <Link
                                            to="/"
                                            className="nav-link"
                                            activeClassName="router-link-active"
                                        >
                                            Home
                                        </Link>
                                        <Link
                                            to="/Mitglieder"
                                            className="nav-link"
                                            activeClassName="router-link-active"
                                        >
                                            Mitglieder
                                        </Link>
                                        <Link
                                            to="/Partnerschaften"
                                            className="nav-link"
                                            activeClassName="router-link-active"
                                        >
                                            Partnerschaften
                                        </Link>

                                        <Link
                                            to="/Dienstleistungen"
                                            className="nav-link h-full mt-7"
                                            activeClassName="router-link-active"
                                            onMouseEnter={() =>
                                                setHoverDienstleitung(true)
                                            }
                                            onMouseLeave={() =>
                                                setHoverDienstleitung(false)
                                            }
                                        >
                                            Dienstleistungen{'  '}
                                            <FontAwesomeIcon
                                                icon={faSortDown}
                                            />
                                        </Link>
                                        <a
                                            className="nav-link h-full mt-7"
                                            onMouseEnter={() =>
                                                setHoverInformationen(true)
                                            }
                                            onMouseLeave={() =>
                                                setHoverInformationen(false)
                                            }
                                        >
                                            Informationen{'  '}
                                            <FontAwesomeIcon
                                                icon={faSortDown}
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Whats in the mobile Nav */}
                    <Disclosure.Panel className="lg:hidden">
                        <div className="px-2 pt-2 pb-3 mobileNav">
                            <Link
                                to="/"
                                className="nav-link text-lg block"
                                activeClassName="router-link-active"
                            >
                                Home
                            </Link>
                            <Link
                                to="/Mitglieder"
                                className="nav-link text-lg block"
                                activeClassName="router-link-active"
                            >
                                Mitglieder
                            </Link>
                            <Link
                                to="/Partnerschaften"
                                className="nav-link text-lg block"
                                activeClassName="router-link-active"
                            >
                                Partnerschaften
                            </Link>
                            <Link
                                to="/Dienstleistungen"
                                className="nav-link text-lg block"
                                activeClassName="router-link-active"
                            >
                                Dienstleistungen
                            </Link>
                            <div className="pl-4 ">
                                <Link
                                    to="/Dienstleistungen/Keys"
                                    className="nav-link block text-base category"
                                    activeClassName="router-link-active"
                                >
                                    {'>'}Keys
                                </Link>
                                <Link
                                    to="/Dienstleistungen/Commission-Hub"
                                    className="nav-link block text-base category"
                                    activeClassName="router-link-active"
                                >
                                    {'>'}Commission Hub
                                </Link>
                            </div>
                            <a
                                className="nav-link block text-lg"
                                activeClassName="router-link-active"
                            >
                                Informationen
                            </a>
                            <div className="pl-4 ">
                                <Link
                                    to="/Kontakt"
                                    className="nav-link block text-base category"
                                    activeClassName="router-link-active"
                                >
                                    {'>'}Kontakt
                                </Link>
                                <Link
                                    to="/Informationen/FAQ"
                                    className="nav-link block text-base category"
                                    activeClassName="router-link-active"
                                >
                                    {'>'}FAQ
                                </Link>
                            </div>
                        </div>
                    </Disclosure.Panel>

                    {/* MEGA Menu - Dienstleistungen */}

                    {hoverDienstleitung && (
                        <div
                            onMouseEnter={() => setHoverDienstleitung(true)}
                            onMouseLeave={() => setHoverDienstleitung(false)}
                            className="fixed top-[64px] left-0 w-full px-10 pt-14 pb-20 bg-gray-800 text-white z-[110] shadow-2xl"
                        >
                            <div className="text-center">
                                <h2 className="tracking-tight font-extrabold text-4xl mb-2 gradientText">
                                    Dienstleistungen
                                </h2>
                                <p>
                                    Hier findest du verschiedene Dienste für und
                                    von Mitgliedern.
                                </p>
                            </div>
                            <div className="grid grid-cols-3 max-w-7xl text-center mx-auto mt-10">
                                {/* Keys */}
                                <div className="flex flex-col justify-center items-center mx-auto border-r-2 w-full">
                                    <div className="flex flex-row items-center justify-center ">
                                        <img
                                            src="https://shop-the-easycode.de/Bilder/Safe-Spark/Safe-Spark_Key.webp"
                                            alt="Safe Spark Gamekey"
                                            className="h-8 w-auto"
                                        />
                                        <Link
                                            to="/Dienstleistungen/Keys"
                                            className="tracking-tight font-extrabold text-3xl ml-3 transition-all ease-in-out duration-500 hover:text-accentOrange"
                                            activeClassName="router-link-active"
                                        >
                                            Keys
                                        </Link>
                                    </div>
                                </div>

                                {/* Commission Hub */}
                                <div className="flex flex-col justify-start items-center col-span-2 mx-auto pl-4">
                                    <div className="flex flex-row items-center justify-center ">
                                        <img
                                            src="https://shop-the-easycode.de/Bilder/Safe-Spark/Safe-Spark_Comission.webp"
                                            alt="Safe Spark Commission Hub"
                                            className="h-8 w-auto "
                                        />
                                        <Link
                                            to="/Dienstleistungen/Commission-Hub"
                                            className="tracking-tight font-extrabold text-3xl ml-3 hover:text-accentOrange transition-all ease-in-out duration-500"
                                        >
                                            Commission Hub
                                        </Link>
                                    </div>
                                    {/* Categories */}
                                    <div className="tracking-tight font-medium text-md ml-3 transition-all ease-in-out duration-500 w-full mt-4">
                                        <div className="grid grid-cols-3 gap-5 ">
                                            {data.allStrapiCommisionCategory.nodes.map(
                                                category => (
                                                    <Link
                                                        key={category.id}
                                                        to={`/Dienstleistungen/Commission-Hub/${category.Slug}`}
                                                        className="flex items-center justify-center px-4 py-4 bg-gray-900 rounded-2xl shadow-2xl hover:text-accentOrange transition-all duration-500 ease-in-out"
                                                    >
                                                        {category.Kategoriename}
                                                    </Link>
                                                )
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* MEGA Menu - Dienstleistungen */}

                    {hoverInformationen && (
                        <div
                            onMouseEnter={() => setHoverInformationen(true)}
                            onMouseLeave={() => setHoverInformationen(false)}
                            className="fixed top-[64px] left-0 w-full px-10 pt-14 pb-20 bg-gray-800 text-white z-[110] shadow-2xl"
                        >
                            <div className="text-center">
                                <h2 className="tracking-tight font-extrabold text-4xl mb-2 gradientText">
                                    Informationen
                                </h2>
                                {/* <p>
                                    Hier findest du verschiedene Dienste für und
                                    von Mitgliedern.
                                </p> */}
                            </div>
                            <div className="grid grid-cols-2 max-w-7xl text-center mx-auto mt-10">
                                {/* Kontakt */}
                                <div className="flex flex-col justify-center items-center mx-auto border-r-2 w-full">
                                    <div className="flex flex-row items-center justify-center ">
                                        <Link
                                            to="/Kontakt"
                                            className="tracking-tight font-extrabold text-3xl ml-3 hover:text-accentOrange transition-all ease-in-out duration-500"
                                            activeClassName="router-link-active"
                                        >
                                            Kontakt
                                        </Link>
                                    </div>
                                </div>

                                {/* Trovo*/}
                                <div className="flex flex-col justify-center items-center mx-auto w-full">
                                    <div className="flex flex-row items-center justify-center ">
                                        <Link
                                            to="/Informationen/FAQ"
                                            className="tracking-tight font-extrabold text-3xl ml-3 hover:text-accentOrange transition-all ease-in-out duration-500"
                                            activeClassName="router-link-active"
                                        >
                                            FAQ
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
        </Disclosure>
    )
}

export default Navbar
